<template>
    <div id="address-list">
        <!-- 确认按钮 -->
        <div class="btn" :class="type === '2' ? 'shou' : 'ji'">
            <van-button
                    v-show="type === '2'"
                    size="large"
                    type="danger"
                    @click="submitSel">确认选择
            </van-button>
            <van-button size="large" type="danger" @click="addAddress">
                {{$route.params.type === '1' ? '+新增寄件人' : '+新增收货人'}}
            </van-button>
        </div>
        <van-search placeholder="输入姓名/电话/地址" v-model="searchKey"/>
        <!-- 地址列表 -->
        <van-list
                v-model="loading"
                :finished="finished"
                @load="onLoad"
        >
            <address-item
                    v-for="(item, index) in list"
                    :key="item.id"
                    :address-info="item"
                    :type="type"
                    @change="selAddress($event, index)"
                    @timeClick="timeClick(index)"
                    @packClick="packClick(index)"
                    @setDefault="setDefault"
                    @delete="delAddress"
                    @edit="editAddress"
                    @stcChange="stcChange"
            ></address-item>
        </van-list>
    </div>
</template>

<script>
    import {Dialog} from "vant";
    import AddressItem from "../../components/AddressItem.vue";
    import TimePicker from "../../components/TimePicker.vue";

    export default {
        name: "AddressList",
        data() {
            return {
                show: {
                    pack: false,
                    time: false
                },
                index: null,
                // 搜索值
                searchKey: "",
                // 地址类型
                type: this.$route.params.type,
                list: [],
                pageNum: 1,
                loading: false,
                finished: false,
                check: [],
                columns: {},
                timeColumns: []
            };
        },
        components: {
            AddressItem,
            TimePicker
        },
        watch: {
            searchKey() {
                this.finished = false;
                this.pageNum = 1;
                this.loading = true;
                this.list.splice(0, this.list.length);
                this.getAddressList();
            }
        },
        created() {
            this.setTime();
            if (this.type === "1") {
                this.$store.commit({
                    type: "setTitle",
                    title: "寄件人列表"
                });
                [...this.check] = this.$store.state.sendList;
            } else {
                this.$store.commit({
                    type: "setTitle",
                    title: "收货人列表"
                });
                [...this.check] = this.$store.state.acceptList;
            }
        },
        methods: {
            onLoad() {
                this.getAddressList();
            },
            // 手推车
            stcChange(item) {
                if (item.check) {
                    this.check.forEach((val, i) => {
                        if (val.id === item.id) {
                            this.$set(this.check[i], "stc", item.stc);
                        }
                    });
                }
            },
            // 删除地址
            delAddress(item) {
                Dialog.confirm({
                    title: "温馨提示",
                    message: "是否确认删除该地址？"
                })
                    .then(() => {
                        let params = {
                            params: item.id
                        };
                        this.$axios.post("merchantConcat/removeAddress", params).then(res => {
                            if (res.data.code === 200) {
                                if (item.check) {
                                    this.check.forEach((val, i) => {
                                        if (val.id === item.id) {
                                            this.check.splice(i, 1);
                                            this.$store.commit({
                                                type: "delAddress",
                                                t: this.type,
                                                id: item.id,
                                                index: i
                                            });
                                        }
                                    });
                                }
                                this.list.splice(0, this.list.length);
                                this.pageNum = 1;
                                this.loading = true;
                                this.finished = false;
                                this.getAddressList();
                            }
                        });
                    })
                    .catch(() => {
                        return false;
                    });
            },
            // 设为默认
            setDefault(id) {
                this.list.forEach(item => {
                    if (item.default) {
                        item.default = false
                    }
                })
                let params = {
                    params: {
                        addressType: this.type,
                        id: id
                    }
                };
                this.$axios.post("merchantConcat/setAddressDefault", params).then(res => {
                    if (res.data.code === 200) {
                        // this.loading = true;
                        // this.list.splice(0, this.list.length);
                        // this.pageNum = 1;
                        // this.finished = false;
                        // this.getAddressList();
                    }
                });
            },
            // 编辑地址
            editAddress(item) {
                this.check.forEach(val => {
                    this.list.forEach(value => {
                        if (val.id === value.id) {
                            Object.keys(value).forEach(key => {
                                this.$set(val, key, value[key]);
                            });
                        }
                    });
                });
                this.$store.commit({
                    type: "confirmSelect",
                    t: this.type,
                    list: this.check
                });
                this.$router.push({
                    path: "/editaddress/" + this.$route.params.type + "/" + item.id
                });
            },
            // 新增地址
            addAddress() {
                this.$router.push("/addaddress/" + this.type);
            },
            // 获取地址列表
            getAddressList() {
                this.loading = true;
                let params = {
                    params: {
                        addressType: this.type,
                        query: this.searchKey || ""
                    },
                    page: {
                        pageNum: this.pageNum,
                        pageSize: 10
                    }
                };
                this.$axios.post("merchant/getPageAddressByType", params).then(res => {
                    if (res.data.code === 200) {
                        this.loading = false;
                        let data = res.data.data;
                        if (!Array.isArray(data.list)) {
                            this.finished = true;
                            return;
                        }
                        data.list.forEach(val => {
                            if (val.addressDefault === "1") {
                                val.default = true;
                            }
                            if (val.goodsNumber === 0) {
                                val.goodsNumber = null;
                            }
                        });
                        this.check.forEach(val => {
                            data.list.forEach(value => {
                                if (val.id === value.id) {
                                    Object.keys(val).forEach(key => {
                                        if (key !== "default") {
                                            value[key] = val[key];
                                        }
                                    });
                                    value.check = true;
                                }
                            });
                        });
                        this.list = this.list.concat(data.list);
                        this.pageNum++;
                        this.finished = !data.hasNextPage;
                    }
                });
            },
            // 选择地址
            selAddress(item) {
                // 提货地址
                // if (this.type === "1") {
                // if (!item.check) {
                //   this.check.forEach((val, i) => {
                //     if (val.id === item.id) {
                //       this.check.splice(i, 1);
                //       return;
                //     }
                //   });
                //   return;
                // }
                // if (this.check.length > 0) {
                //   let arr = this.check;
                //   let lat = arr[0].lat;
                //   let lng = arr[0].lng;
                //   let clothingCityId = arr[0].clothingCityId;
                //   let provinceName = arr[0].provinceName;
                //   let cityName = arr[0].cityName;
                //   let districtName = arr[0].districtName;
                //   if (
                //     lat !== 0.0 &&
                //     lng !== 0.0 &&
                //     item.lat !== 0.0 &&
                //     item.lng !== 0.0
                //   ) {
                //     let obj1 = { lat, lng };
                //     let obj2 = { lat: item.lat, lng: item.lng };
                //     if (this.radLat(obj1, obj2) <= 3) {
                //       this.check.push(item);
                //       return;
                //     }
                //   } else if (
                //     clothingCityId !== "" &&
                //     item.clothingCityId === clothingCityId
                //   ) {
                //     this.check.push(item);
                //     return;
                //   } else if (
                //     provinceName === item.provinceName &&
                //     cityName === item.cityName &&
                //     districtName === item.districtName
                //   ) {
                //     this.check.push(item);
                //     return;
                //   }
                //   Dialog.alert({
                //     title: "温馨提示",
                //     message: "提货地址不能跨区下单！"
                //   }).then(() => {
                //     item.check = false;
                //     return false;
                //   });
                // } else {
                //   this.check.push(item);
                // }
                // }
                // 收货地址
                // else {
                this.list.forEach(val => {
                    if (val.id !== item.id) {
                        this.$set(val, "check", false);
                    } else {
                        this.$set(val, "check", true);
                    }
                    this.check = [item];
                    this.$store.commit({
                        type: "confirmSelect",
                        t: this.type,
                        list: this.check
                    });
                });
                if (this.$route.name === "OrderAddressList") {
                    this.$router.push("/order/modify/" + this.$route.params.id);
                } else {
                    this.$router.push("/preorder");
                }
                // }
            },
            // 确认选择
            submitSel() {
                if (this.check.length <= 0) {
                    Dialog.alert({
                        title: "温馨提示",
                        message: "请至少选择一个提货地址！"
                    }).then(() => {
                        return false;
                    });
                } else {
                    this.check.forEach(val => {
                        this.list.forEach(value => {
                            if (val.id === value.id) {
                                Object.keys(value).forEach(key => {
                                    this.$set(val, key, value[key]);
                                });
                            }
                        });
                    });
                    this.$store.commit({
                        type: "confirmSelect",
                        t: this.type,
                        list: this.check
                    });
                    if (this.$route.name === "OrderAddressList") {
                        this.$router.push("/order/modify/" + this.$route.params.id);
                    } else {
                        this.$router.push("/preorder");
                    }
                }
            },
            // 计算省市区距离
            rad(lat) {
                return (lat * Math.PI) / 180;
            },
            radLat(obj1, obj2) {
                let lat1 = obj1.lat,
                    lng1 = obj1.lng,
                    lat2 = obj2.lat,
                    lng2 = obj2.lng;
                let a = this.rad(lat1) - this.rad(lat2);
                let b = this.rad(lng1) - this.rad(lng2);
                let s =
                    2 *
                    Math.asin(
                        Math.sqrt(
                            Math.pow(Math.sin(a / 2), 2) +
                            Math.cos(this.rad(lat1)) *
                            Math.cos(this.rad(lat2)) *
                            Math.pow(Math.sin(b / 2), 2)
                        )
                    );
                s = s * 6378.137;
                s = Math.round(s * 10000) / 10000;
                s = parseInt(s);
                return s;
            },
            // --------------------------------
            // --------------------------------
            // --------------------------------
            // 时间选择器
            timeClick(index) {
                this.index = index;
                this.show.time = true;
            },
            setTime() {
                let hour = new Date().getHours();
                let minute = new Date().getMinutes();
                let hours = [];
                let minutes = [];
                let h1 = hour;
                let m1 = minute;
                for (let i = hour; i <= 23; i++) {
                    hours.push(h1 < 10 ? "0" + h1 + "时" : h1 + "时");
                    h1++;
                }
                let hours1 = [];
                for (let i = 0; i <= 23; i++) {
                    hours1.push(i < 10 ? "0" + i + "时" : i + "时");
                }
                for (let i = minute; i <= 59; i++) {
                    minutes.push(m1 < 10 ? "0" + m1 + "分" : m1 + "分");
                    m1++;
                }
                let minutes1 = [];
                for (let i = 0; i <= 59; i++) {
                    minutes1.push(i < 10 ? "0" + i + "分" : i + "分");
                }

                let columns = {};
                columns.今天 = {};
                columns.明天 = {};
                columns.后天 = {};
                for (let i = 0; i < hours.length; i++) {
                    if (i === 0) {
                        columns.今天[hours[i]] = minutes;
                    } else {
                        columns.今天[hours[i]] = minutes1;
                    }
                }
                for (let i = 0; i < hours1.length; i++) {
                    columns.明天[hours1[i]] = minutes1;
                    columns.后天[hours1[i]] = minutes1;
                }
                this.columns = columns;
                this.timeColumns = [
                    {
                        values: Object.keys(columns),
                        className: "column1"
                    },
                    {
                        values: Object.keys(columns.今天),
                        className: "column2",
                        defaultIndex: 0
                    },
                    {
                        values: columns.今天[hours[0]],
                        className: "column3",
                        defaultIndex: 0
                    }
                ];
            },
            onChange(picker, values, i) {
                if (i === 0) {
                    picker.setColumnValues(1, Object.keys(this.columns[values[0]]));
                    picker.setColumnValues(
                        2,
                        this.columns[values[0]][this.$refs.timePicker.getColumnValue(1)]
                    );
                }
                if (i === 1) {
                    picker.setColumnValues(2, this.columns[values[0]][values[1]]);
                }
            },
            emptyTime() {
                this.$set(this.list[this.index], "planDeliveryDate", "");
                if (this.list[this.index].check) {
                    this.check.forEach((val, i) => {
                        if (val.id === this.list[this.index].id) {
                            this.$set(this.check[i], "planDeliveryDate", "");
                        }
                    });
                }
                this.show.time = false;
            },
            confirmTime(value) {
                this.$set(
                    this.list[this.index],
                    "planDeliveryDate",
                    value[0] +
                    " " +
                    value[1].substring(0, value[1].length - 1) +
                    ":" +
                    value[2].substring(0, value[2].length - 1)
                );
                if (this.list[this.index].check) {
                    this.check.forEach((val, i) => {
                        if (val.id === this.list[this.index].id) {
                            this.$set(
                                this.check[i],
                                "planDeliveryDate",
                                value[0] +
                                " " +
                                value[1].substring(0, value[1].length - 1) +
                                ":" +
                                value[2].substring(0, value[2].length - 1)
                            );
                        }
                    });
                }
                this.show.time = false;
            },
            // 包装选择
            packClick(index) {
                this.index = index;
                this.show.pack = true;
            },
            emptyPack() {
                this.$set(this.list[this.index], "packId", "");
                this.$set(this.list[this.index], "packName", "");
                if (this.list[this.index].check) {
                    this.check.forEach((val, i) => {
                        if (val.id === this.list[this.index].id) {
                            this.$set(this.check[i], "packId", "");
                            this.$set(this.check[i], "packName", "");
                        }
                    });
                }
            },
            selPack(item) {
                this.$set(this.list[this.index], "packId", item.dictValue);
                this.$set(this.list[this.index], "packName", item.dictName);
                if (this.list[this.index].check) {
                    this.check.forEach((val, i) => {
                        if (val.id === this.list[this.index].id) {
                            this.$set(this.check[i], "packId", item.dictValue);
                            this.$set(this.check[i], "packName", item.dictName);
                        }
                    });
                }
                this.show.pack = false;
            }
        }
    };
</script>

<style scoped lang="scss">
    #address-list {
        padding-top: 60px;
        flex: 1;
        overflow: scroll;

        .van-cell-group {
            margin-bottom: 50px;

            &:after {
                border: 0;
            }
        }

        .title {
            display: flex;
            align-items: center;
            position: relative;

            &::after {
                content: "";
                position: absolute;
                top: 99%;
                left: 15px;
                right: 0;
                height: 1px;
                margin-top: 5px;
                border-bottom: 1px solid #e5e5e5;
            }

            .shoutuiche {
                line-height: 20px;
                font-size: 14px;

                .stc-check {
                    margin: 0 0.25rem;
                    margin-top: -2px;
                    margin-bottom: 1px;
                    vertical-align: middle;
                    display: inline-block;
                    width: 20px;
                    height: 20px;
                    outline: 0;
                    background-color: transparent;
                    background-image: none;
                    -webkit-appearance: none;
                    font-family: vant-icon;
                    border: 1px solid #aaa;
                    border-radius: 50%;
                    text-align: center;
                    line-height: 20px;

                    &:before {
                        content: "";
                        display: inline-block;
                    }

                    &:checked {
                        color: #fff;
                        background-color: #06bf04;
                        border-color: #06bf04;

                        &:before {
                            content: "\F0C1";
                            display: inline-block;
                        }
                    }
                }
            }

            .detail-list {
                margin-left: 0.375rem;
                width: 100%;

                .row {
                    display: flex;
                    align-items: center;
                    width: 100%;
                    margin: 0.15rem 0;
                    box-sizing: border-box;
                    position: relative;

                    .address {
                        padding-right: 1.4rem;
                    }

                    &.detail {
                        padding-left: 0.25rem;
                    }

                    .phone {
                        margin-left: 0.25rem;
                        color: #999;
                        flex: 1;
                    }

                    .detail-input {
                        width: 1.55rem;
                        /*margin-right: 0.25rem;*/
                        background-color: #eee;
                        border-radius: 5px;
                    }

                    .check {
                        display: flex;
                        align-items: center;

                        .van-checkbox {
                            margin-left: 0.25rem;
                        }

                        &.setDefault {
                            padding-left: 0.25rem;
                        }
                    }

                    .edit-btn {
                        position: absolute;
                        right: 0;

                        .van-icon {
                            margin-left: 0.45rem;
                            color: #666;
                        }
                    }
                }
            }
        }

        .btn {
            background: #fff;
            position: fixed;
            /*bottom: 0;*/
            top: 45px;
            z-index: 90;
            left: 0;
            right: 0;
            display: flex;
            justify-content: space-around;

            .van-button {
                width: 80%;
            }

            &.shou {
                .van-button {
                    width: 45%;
                }
            }
        }
    }
</style>
